import React from 'react';
import moment from 'moment';
import DetailsBar from '../shared/DetailsBar';
import BackButton from '../shared/BackButton';
import HeadingPlaceholder from '../shared/HeadingPlaceholder';
import TextAreaView from '../shared/TextAreaView';
import SVGTrash from '../../svg/Trash';
import SVGMail from '../../svg/Mail';
import SVGDownload from '../../svg/Download';
import ServiceCharge from './ServiceCharge';
import ServiceClient from './ServiceClient';
import ServiceStaff from './ServiceStaff';
import ServiceMenu from './ServiceMenu';
import {
  maskServiceDate,
  maskServiceStartTime,
  maskServiceEndTime,
  maskPrependComma
} from '../../masks';
import { calcTax } from '../../helpers/util';
import { taxRate } from '../../const';

class ServiceWeekly extends React.Component {
  state = {};

  detailBarProperties = [
    {
      label: 'Date & Time',
      className: 'p',
      combine: [
        { key: 'date', mask: maskServiceDate },
        { raw: ' ', className: '--new-line' },
        { key: 'start_time', mask: maskServiceStartTime },
        { key: 'end_time', mask: maskServiceEndTime }
      ]
    },
    { label: 'Portion Size', key: 'portion_size', className: 'p --capitalize' },
    { label: 'Diet', key: 'client', dive: ['dietary_preference_tags', 'tag'] },
    {
      label: 'Allergens',
      key: 'client',
      combine: [
        { key: 'allergen_tags', dive: 'tag' },
        { key: 'other_allergens', mask: maskPrependComma }
      ]
    }
  ];

  render() {
    const {
      service,
      updateService,
      submitService,
      setServiceUnsaved,
      updateMenuSelections,
      openModal,
      isClientEdit,
      isMenuEdit,
      isStaffEdit,
      sendStaffMail,
      downloadChefMaterials,
      isDownloading
    } = this.props;

    return (
      <div className="cms--service">
        <div className="cms__head cms__head--padding">
          <div className="cms__content">
            <BackButton defaultUrl="/admin/services" />
            <div className="cms__bar">
              <HeadingPlaceholder
                value={service.name}
                placeholder="Weekly Service"
                label="Weekly Service"
              />
              <div className="cms__bar-ctas">
                {service.id && !isDownloading ? (
                  <div
                    className="btn-icon btn-icon--download"
                    onClick={downloadChefMaterials}
                  >
                    <SVGDownload />
                  </div>
                ) : (
                  ''
                )}
                {service.id && isDownloading ? (
                  <div className="p">downloading...</div>
                ) : (
                  ''
                )}
                {service.id ? (
                  <div
                    className="btn-icon btn-icon--mail"
                    onClick={() => this.props.openSendDetailsModal()}
                  >
                    <SVGMail />
                  </div>
                ) : (
                  ''
                )}
                {service.id ? (
                  <div
                    className="btn-icon btn-icon--trash"
                    onClick={() => openModal('delete')}
                  >
                    <SVGTrash />
                  </div>
                ) : (
                  ''
                )}
                  {process.env.REACT_APP_SHOW_SMS_REMINDER_BUTTON && (
                    <div
                      className="btn btn--hollow-blue"
                      onClick={() => openModal('send-menu-sms-reminder')}
                    >
                      Send SMS
                    </div>
                  )}
                <div
                  className="btn btn--hollow-blue"
                  onClick={() => openModal('edit-details')}
                >
                  Edit Details
                </div>
                <input
                  type="submit"
                  className="btn btn--solid-blue"
                  value="Save"
                  onClick={() => submitService()}
                />
              </div>
            </div>
            <DetailsBar data={service} columns={this.detailBarProperties} />
          </div>
        </div>

        <div className="cms__body">
          <div className="cms__content">
            <ServiceClient
              openModal={() => openModal('add-client')}
              isEdit={isClientEdit}
              client={service.client}
              address={service.address}
              updateService={updateService}
            />

            <ServiceMenu
              openDishModal={() => openModal('add-dish')}
              openMenuModal={() => openModal('add-menu')}
              openGroceryList={this.props.openGroceryList}
              setServiceUnsaved={setServiceUnsaved}
              service={service}
              updateService={updateService}
              updateMenuSelections={updateMenuSelections}
              isEdit={isMenuEdit}
            />

            <ServiceStaff
              openAddStaffModal={() => openModal('add-staff')}
              sendStaffMail={sendStaffMail}
              service={service}
              updateService={updateService}
              isEdit={isStaffEdit}
              openSendDetailsModal={staff =>
                this.props.openSendDetailsModal(staff)
              }
            />

            <div className="row">
              <div className="row__item row__item--half row__item--pad-right">
                <ServiceCharge
                  service={service}
                  updateService={updateService}
                />
              </div>
              <div className="row__item row__item--half row__item--pad-left">
                <TextAreaView
                  value={service.notes}
                  openEdit={() => openModal('notes')}
                />
              </div>
            </div>

            {service.id && (
              <div className="row">
                <div
                  className="btn btn--hollow-red"
                  onClick={() => this.props.openModal('skip-week')}
                >
                  Skip Week
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  componentDidUpdate(prevProps) {
    const status = this.props.service.status;
    if (prevProps.service.status !== status) {
      if (status === "client_cancelled") {
        // update fees
        const twoDaysFromNow = moment().add(48, 'hours');
        const lessThan48hrsAway = moment(this.props.service.true_start_time).diff(twoDaysFromNow) < 0

        let fee_cents = this.props.service.fee_cents

        // if less than 48 hours away, fee stays the same, else goes to 0
        if (!lessThan48hrsAway) {
          fee_cents = 0
        }

        const tax_cents = calcTax(fee_cents, taxRate);
        this.props.updateService({ fee_cents, travel_cents: 0, tip_cents: 0, tax_cents})
      }
    }
  }
}
export default ServiceWeekly;



// WEBPACK FOOTER //
// ./src/components/service/ServiceWeekly.js